module.exports = __webpack_public_path__ + "static/media/placeholder-04.b5f9acd0.png";